<template>
    <div style="background-color: #f2f2f2;height: 100%;">
        <div v-if="showModal" class="mask">
            <div class="lodingsIcon">
                <i class="el-icon-loading"></i><span>正在处理，请等待。。。</span>
            </div>
        </div>
        <div style="background-color: #fff;padding:0px 20px; line-height: 50px;border-bottom: 1px solid #ddd;">
            本月过生日的老人列表
        </div>
        <div style="padding: 20px;">
            <div>
                <el-row>
                    <div style="float:right">
                    <el-input placeholder="请输入姓名" v-model="name" maxlength="11" clearable
                                style="width:200px;margin-right:10px"></el-input>
                    <el-date-picker
                        v-model="startTime" value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="选择日期">
                    </el-date-picker>
                    <el-button type="primary" style="margin-left:10px" icon="el-icon-search" @click="getList">搜索</el-button></div>
                </el-row>

                <div style="clear: both;"></div>
            </div>

            <div style="height: 10px;"></div>

            <div>
                <template>

                    <el-table :data="tableData"
                              :height="th"
                              border
                              style="width: 100%;"
                              v-loading="loading"
                              :row-class-name="tableRowClassName">
                        <el-table-column prop="userName" fixed="left" label="姓名" ></el-table-column>
                        <el-table-column prop="userPhone" label="手机号" ></el-table-column>
                        <el-table-column prop="age" label="年龄" ></el-table-column>
                        <el-table-column prop="gender" label="性别" :formatter="genderFormat" ></el-table-column>
                        <el-table-column prop="birthday" :formatter="getTime" label="出生日期" ></el-table-column>
                        <el-table-column prop="homeAddress"  label="家庭地址" width="600" ></el-table-column>

                        <el-table-column fixed="right" label="操作" width="200">
                            <template slot-scope="scope">
                                <el-button type="warning" size="mini" @click="handleInfo(scope.row)">老人档案 </el-button>
                            </template>
                        </el-table-column>

                    </el-table>

                    <div style="text-align: left;background-color: #fff;padding: 10px;">
                        <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
                        </div>
                        <div style="float: left;">
                            <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    :total="totalItems"
                                    :page-size="20"
                                    :current-page.sync="currentPage"
                                    @current-change="current_change">
                            </el-pagination>
                        </div>
                        <div style="clear: both;"></div>
                    </div>


                </template>
            </div>

        </div>
        <OldManFile ref="myOldManFile" v-show="showModalOldManFile" v-on:closeInfo="closeOldManFile" v-on:getList="getList"></OldManFile>
    </div>
</template>

<script>

    import {timeStr, timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import elderly from "@/common/status";
    import OldManFile from "./OldManFile";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data() {
            return {
                uploadUrl:this.$shopUrl+'ImportExcel/Import',
                uploadData:{
                    staffCode:getStaffCode(),
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
                },
                startTime:'',
                batchFileList:[],
                batchDialog:false,
                batchDialogError:false,
                errorData:[],
                showModal:false,
                showModalDevice:false,
                censusRegister:'',
                loading: false,
                showModalAdd: false,
                showModalOldManFile: false,
                datetimerangeValue: '',
                showModalEdit: false,
                showModalSearch: false,
                tableData: null,
                totalItems: 0,
                pageSize: 20,
                currentPage: 1,
                th: 0,
                name: '',
                idCard: '',
                ctiyDate: [],
                elderlyType: elderly.serviceType,
                elderlyClassValue: [],
                nationValue: [],
                zoneValue: [],
                areaValue: [],
                zoneCode: '00000000-0000-0000-0000-000000000000',
                elderlyAllType: elderly,
                zoneProps: {
                    emitPath: false,
                    value: 'zoneCode',
                    // 显示的文字字段名
                    label: 'name',
                    // 子层级字段名
                    children: 'listZoneDTO'
                },
                phone: '',
                elderlyClassList:'',
                censusRegisterList:['城市','农村'],
                status:-1,
                statusList: [
                    {
                    value: -1, label: '全部状态'
                    }, {
                    value: 1, label: '正常'
                    }, {
                    value: 2, label: '禁用'
                    }
                ],
            }
        },
        components: {
            OldManFile
        },

        created() {

            this.init();
            this.th = this.$store.state.tableHeight;
        },

        watch: {
            //监听全局变量
            '$store.state.tableHeight': function (val) {
                this.th = val;
            },
        },
        methods: {
            init: function () {
                const end = new Date();
                const start = new Date(end - 1000 * 60 * 60 * 24 * 365);
                this.datetimerangeValue = [start, end];
                this.getList();
            },
            closeBatchDialog(){
                this.$refs.upload.clearFiles();
            },
            uploadSuccess(response){
                // this.$refs.bulkUpload.clearFiles()
                if(response.error === 0){
                    this.batchDialog=false
                    this.uuid = response.data;
                    // this.getList()
                }else if(response.error === 1){
                    this.$message.error(response.data.message)
                }
                
            },
            getZoneValue(val) {
                this.zoneCode = val
            },
            getTime(row,index,column){
                return timefilters(column).substring(0,10)
            },
            tableRowClassName({row}) {
                const timeAudit = new Date(row.timeAudit);
                const end = new Date();
                const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
                if (timeAudit >= start) {
                    return 'success-row';
                }
                return '';
            },
            getAge(row) {
                var identityCard = row.idCard;

                var len = (identityCard + "").length;
                if (len == 0) {
                    return 0;
                } else {
                    if ((len != 15) && (len != 18))//身份证号码只能为15位或18位其它不合法
                    {
                        return 0;
                    }
                }
                var strBirthday = "";
                if (len == 18)//处理18位的身份证号码从号码中得到生日和性别代码
                {
                    strBirthday = identityCard.substr(6, 4) + "/" + identityCard.substr(10, 2) + "/" + identityCard.substr(12, 2);
                }
                if (len == 15) {
                    strBirthday = "19" + identityCard.substr(6, 2) + "/" + identityCard.substr(8, 2) + "/" + identityCard.substr(10, 2);
                }
                //时间字符串里，必须是“/”
                var birthDate = new Date(strBirthday);
                var nowDateTime = new Date();
                var age = nowDateTime.getFullYear() - birthDate.getFullYear();
                //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
                if (nowDateTime.getMonth() < birthDate.getMonth() || (nowDateTime.getMonth() == birthDate.getMonth() && nowDateTime.getDate() < birthDate.getDate())) {
                    age--;
                }
                return age;

            },
            submitUpload(){
                this.showModal=true
                this.$refs.upload.submit();
                this.crontab();
            },
            crontab() {
                this.timer = setInterval(this.getSuccess, 1000 * 1);
            },
            genderFormat(row){
                if(row.gender==0){
                    return '女'
                }else{
                    return '男'
                }
            },
            getSuccess() {
                this.$axios({
                method: 'post',
                url: this.$shopUrl + "ImportExcel/IsSuccess",
                data: {
                    uuid: this.uuid
                }
                }).then((response) => {
                if (response.data.error === 0) {
                    this.showModal=true
                    this.isSuccess = response.data.data;
                    if (this.isSuccess === "0") {
                    this.showModal=true
                    }
                    if (this.isSuccess === "1") {
                    this.$message({type: 'success', message: '导入成功'});
                    this.showModal=false
                    this.getList();
                    this.inCrontab();

                    }
                    if (this.isSuccess === "2") {
                    this.$message({type: 'success', message: '导入失败'});
                    // this.getList();
                    this.inCrontab();
                    this.showModal=false
                    }
                    if (this.isSuccess !== "1" && this.isSuccess !== "2" && this.isSuccess !== "0") {
                        if(this.isSuccess.length>10){
                            this.batchDialogError=true
                            this.errorData=this.isSuccess.split('<br>')
                        }else{
                            this.$message.error({type: 'success', message: this.isSuccess});
                        }
                        
                        this.inCrontab();
                        this.showModal=false
                    }


                } else if (response.data.error === 1) {
                    this.$message.error(response.data.message)
                } else if (response.data.error === 2) {
                    this.$message({type: 'success', message: '导入失败'});
                    this.inCrontab();
                    this.showModal=false
                }
                }).catch(function (error) {
                console.log(error);
                });
            },
            inCrontab() {
                clearInterval(this.timer);
            },
            getTemplate(){
                var that=this
                this.$axios.get(this.$shopUrl+'ImportExcel/GetElderlyTemplate',{
                    responseType: 'blob',
                    params:{
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                        staffCode: getStaffCode(),
                    }
                }).then(
                    (response) => {
                        let fileName = '老人导入模板.xlsx';
                        that.file(response,fileName);
                    }
                )
            },
            file(response, fileName) {
                let blob = new Blob([response.data]);
                if (window.navigator.msSaveOrOpenBlob) {
                    navigator.msSaveBlob(blob, fileName);
                } else {
                    let elink = document.createElement("a");
                    elink.download = fileName;
                    elink.style.display = "none";
                    elink.href = URL.createObjectURL(blob)
                    document.body.appendChild(elink);
                    elink.click();
                    URL.revokeObjectURL(elink.href);
                    document.body.removeChild(elink);
                }
            },
            handleEdit(row) {
                this.$refs.myEdit.init(row);
                this.showModalEdit = !this.showModalEdit;
            },
            handleInfo(row) {
                this.$refs.myOldManFile.init(row);
                this.showModalOldManFile = !this.showModalOldManFile;
            },
            toggleModalAdd: function () {
                this.showModalAdd = !this.showModalAdd;
                this.$refs.myAdd.init();
            },
            closeAdd: function () {
                this.showModalAdd = !this.showModalAdd;
            },
            closeOldManFile(){
                this.showModalOldManFile = !this.showModalOldManFile;
            },
            toggleModalSearch: function () {
                this.showModalSearch = !this.showModalSearch;
                this.$refs.mySearch.init();
            },
            closeSearch: function () {
                this.showModalSearch = !this.showModalSearch;
            },
            toggleModalEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
            closeEdit: function () {
                this.showModalEdit = !this.showModalEdit;
            },
          closeDevice:function (){
            this.showModalDevice = !this.showModalDevice;
          },

            current_change: function (currentPage) {
                this.currentPage = currentPage;
                this.getList();
            },

          DeviceManage(index, row){
            this.$refs.myPageForDevice.init(row);
            this.showModalDevice = !this.showModalDevice;
          },

            getList(isSearch){
                if(isSearch)this.currentPage=1
                var _this = this
                this.loading=true;
                this.$axios({
                    method: 'post',
                    url: this.$shopUrl + "Elderly/CarePage",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
                        staffCode: getStaffCode(),
                        // startTime: timefilters(this.datetimerangeValue[0]),
                        // endTime: timefilters(this.datetimerangeValue[1]),
                        pageIndex: this.currentPage,
                        pageSize: this.pageSize,
                        name:this.name,
                        startTime:this.startTime
                    }
                }).then((response) => {
                    this.loading=false;
                    if (response.data.error == 0) {
                      this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    } else if (response.data.error == 1) {
                      this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    _this.loading=false;
                    console.log(error);
                });
            },
             userStatus(row) {
                if (row.userStatus == 1) {
                    return "正常";
                }
                if (row.userStatus == 2) {
                    return "禁用";
                }
                return "其它";
            },
            elderlyTypes(row) {
                if (row.elderlyType == 0) {
                    return "政府购买服务";
                }
                if (row.elderlyType == 1) {
                    return "有偿服务";
                }
                if (row.elderlyType == -1) {
                    return "";
                }
                return "其它";
            },
            politics(row) {
                return this.allStatus(row.politicsStatus, elderly.politicalOutlook);
            },
            censusRegisters(row) {
                return this.allStatus(row.censusRegister, elderly.natureHRegistrater);
            },
            educations(row) {
                return this.allStatus(row.education, elderly.education);
            },
            allStatus(row, status) {
                for (var i in status) {
                    if (status[i].value == row) {
                        return status[i].label
                    }
                }
                return "其它";
            },
            elderlyClass(row){
            for (var i=0;i<this.elderlyClassList.length;i++){
              if(row.elderlyClass===this.elderlyClassList[i].value){
                return this.elderlyClassList[i].name;
                }
              }
            },

        }
    }
</script>
<style>
    .el-table .success-row {
        background: #f0f9eb;
    }
</style>
<style   lang="scss" scoped>
    .mask {
        background-color: rgb(0, 0, 0);
        opacity: 0.3;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 199
      }
      .mask .lodingsIcon{
        /* margin-top: 47vh; */
        margin: 47vh auto;
        height: 6vh;
        width: 300px;
        font-size: 18px;
        color: white;
      }
      .lodingsIcon i{
        z-index: 200;
        font-size: 25px;
        margin-right:10px ;
        
      }
</style>
